import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Field, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { Radio } from 'web-ui-components/lib/atoms/forms';
import { paymentPropTypes } from '../../../states/payments/propTypes';
import {
	updateFrequency,
	updateStopPaymentOption,
	updateDate,
	updateStopPaymentOnDate,
	updateStopPaymentOnNumber,
} from '../../../states/payments/actions';
import { dateFormat, dateFormatFocus, dateFormatToday, MaximumRepeatingTimes } from '../../../config/';
import PaymentRepeatingTimes from './PaymentRepeatingTimes';
import PaymentFrequency from './PaymentFrequency';
import { updateValidation, hideErrorMsg } from '../../../states/validation/actions';
import { getValidationRowState } from '../../../states/validation/selectors';
import { isDateToday } from './Form/PaymentDate';
import DateField from '../../../sharedComponents/DateField/DateField';

const mapState = (state, props) => ({
	validations: getValidationRowState(state, props.id),
});

const mapDispatch = (dispatch, props) => ({
	handleSelectFrequency: (event) => dispatch(updateFrequency({ id: props.id, frequency: event.target.value })),
	handlePaymentDateChange: (date) => dispatch(updateDate({ id: props.id, date: date || moment().add(1, 'day') })),
	handleRadioButtonClick: (stopPaymentOption) =>
		dispatch(
			updateStopPaymentOption({
				id: props.id,
				stopPaymentOption,
				stopPaymentOnDate: stopPaymentOption === 'on-date' ? moment(props.date) : undefined,
			})
		),
	handleStopPaymentOnNumberChange: (numberOfTimesPaymentRepeating) =>
		dispatch(updateStopPaymentOnNumber({ id: props.id, stopPaymentOnNumber: numberOfTimesPaymentRepeating })),
	handleStopPaymentOnDateChange: (stopPaymentOnDate) =>
		dispatch(updateStopPaymentOnDate({ id: props.id, stopPaymentOnDate: stopPaymentOnDate || moment() })),

	updateValidation: (key, isValid) =>
		dispatch(
			updateValidation({
				id: props.id,
				key,
				isValid,
			})
		),
	hideErrorMsg: (key) =>
		dispatch(
			hideErrorMsg({
				id: props.id,
				key,
			})
		),
});

class PaymentRepeating extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			stopPaymentDateFormat: dateFormat,
			firstPaymentDateFormat: isDateToday(this.props.date, this.props.todaysDate) ? dateFormatToday : dateFormat,
		};
	}

	render() {
		const {
			stopPaymentOption,
			frequency,
			date,
			stopPaymentOnDate,
			stopPaymentOnNumber,
			handleSelectFrequency,
			handlePaymentDateChange,
			handleRadioButtonClick,
			handleStopPaymentOnNumberChange,
			handleStopPaymentOnDateChange,
			todaysDate,
			content,
			validations,
			updateValidation,
			hideErrorMsg,
		} = this.props;

		const minStopDate = moment(date);

		return (
			<div className="u-margin-top-2">
				<PaymentFrequency
					frequency={frequency}
					frequencyLabel={content.frequencyLabel}
					handleSelectFrequency={handleSelectFrequency}
					updateValidation={updateValidation}
					validations={validations}
					hideErrorMsg={hideErrorMsg}
				/>
				<Field>
					<FieldHeader name="field-first-payment-date" titleText={content.firstPaymentLabel} />
					<FieldBody>
						<DateField
							id="field-first-payment-date"
							dateFormat={this.state.firstPaymentDateFormat}
							minDate={moment(todaysDate).add(1, 'day')}
							maxDate={moment(todaysDate).add(1, 'year')}
							className="u-flex"
							selectedDate={moment(date)}
							onFocus={() => this.setState({ firstPaymentDateFormat: dateFormatFocus })}
							onBlur={() => this.setState({ firstPaymentDateFormat: dateFormat })}
							onChange={handlePaymentDateChange}
						/>
					</FieldBody>
				</Field>
				<Field className="u-margin-bottom-2">
					<FieldHeader name="cancel-on" titleText={content.stopPaymentLabel} />
					<div>
						<Radio
							id="radio-block-on-cancel"
							block
							label={content.radioBlockOnCancelLabel}
							onClick={() => handleRadioButtonClick('on-cancel')}
							checked={stopPaymentOption === 'on-cancel'}
							onChange={() => {}}
						/>
						<Radio
							id="radio-block-on-number"
							block
							label={content.radioBlockOnNumberLabel}
							onClick={() => handleRadioButtonClick('on-number')}
							checked={stopPaymentOption === 'on-number'}
							onChange={() => {}}
						/>
						<Radio
							id="radio-block-on-date"
							block
							label={content.radioBlockOnDateLabel}
							onClick={() => handleRadioButtonClick('on-date')}
							checked={stopPaymentOption === 'on-date'}
							onChange={() => {}}
						/>
					</div>
				</Field>

				{stopPaymentOption === 'on-number' && (
					<PaymentRepeatingTimes
						stopPaymentOnNumber={stopPaymentOnNumber}
						handleStopPaymentOnNumberChange={handleStopPaymentOnNumberChange}
						stopOnNumberLabel={content.stopOnNumberLabel}
						updateValidation={updateValidation}
						validations={validations}
						hideErrorMsg={hideErrorMsg}
						maximum={MaximumRepeatingTimes}
					/>
				)}

				{stopPaymentOption === 'on-date' && (
					<Field>
						<FieldHeader name="field-stop-payment-date" titleText={content.stopOnDateLabel} />
						<FieldBody>
							<DateField
								id="field-stop-payment-date"
								dateFormat={this.state.stopPaymentDateFormat}
								minDate={minStopDate}
								className="u-flex standalone-date"
								selectedDate={moment(stopPaymentOnDate)}
								onFocus={() => this.setState({ stopPaymentDateFormat: dateFormatFocus })}
								onBlur={() => this.setState({ stopPaymentDateFormat: dateFormat })}
								onChange={handleStopPaymentOnDateChange}
							/>
						</FieldBody>
					</Field>
				)}
			</div>
		);
	}
}

PaymentRepeating.defaultProps = {
	todaysDate: moment(),
	stopPaymentOnDate: moment().add(1, 'day'),
	stopPaymentOption: 'on-cancel',
};

PaymentRepeating.propTypes = {
	...paymentPropTypes,
	handleSelectFrequency: PropTypes.func,
	handleRadioButtonClick: PropTypes.func,
	todaysDate: PropTypes.instanceOf(moment),
	stopPaymentOnDate: PropTypes.instanceOf(moment),
	stopPaymentOption: PropTypes.string,
};

export default connect(mapState, mapDispatch)(PaymentRepeating);
